export default __webpack_public_path__ + "static/media/featured-banner.8a48e090.svg";